import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";
import heroImg from "@/assets/hero-collage.jpg";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const { t } = useI18n();
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="container relative grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <h1 className="font-display text-5xl md:text-7xl font-black leading-[0.95]">
            <span className="text-gradient">{t("hero.title")}</span>
          </h1>
          <p className="text-lg md:text-xl text-gradient max-w-xl">{t("hero.subtitle")}</p>
          <div className="flex justify-center pt-2">
            <Button asChild size="lg" className="bg-neon-green text-background hover:bg-neon-green/90 font-bold text-base h-12 px-7 animate-pulse-glow">
              <a href="#upload">
                {t("hero.cta")} <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
          </div>
          <div className="flex items-center gap-6 pt-4 text-sm">
            <div><span className="text-neon-green font-bold">500+</span> <span className="text-gradient-contact">{t("hero.stat1")}</span></div>
            <div><span className="text-neon-green font-bold">4.9★</span> <span className="text-gradient-contact">{t("hero.stat2")}</span></div>
            <div><span className="text-neon-green font-bold">~30s</span> <span className="text-gradient-contact">{t("hero.stat3")}</span></div>
          </div>
        </div>
        <div className="relative animate-float">
          <div className="absolute -inset-6 bg-gradient-to-tr from-neon-green/30 via-transparent to-neon-purple/30 blur-3xl" />
          <div className="relative rounded-2xl overflow-hidden border border-neon-green/30 glow-purple">
            <img src={heroImg} alt="AI cartoon portrait examples in Neon, Anime, Comic, Cartoon, Ghibli, Oil Painting, Disney, Headshot and Caricature styles" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};
